import Link from "next/link";

// The library licence as stated on /pricing and in its FAQ. Keep in step with
// those pages and with IMAGE_LICENSE in services/structured-data.js.
export default function LicenseNote({ className = "", label = "License:" }) {
    return (
        <p className={className}>
            {label && <b className="font-semibold">{label} </b>}
            Free for personal and educational use. Commercial use requires a{" "}
            <Link href="/pricing">
                <a className="underline hover:text-secondary">paid plan</a>
            </Link>
            .
        </p>
    );
}
